import "./ProposalHeroTriangle.scss"
import { classNames } from "primereact/utils"
import { borderRadius, handleHeroMediaType, handleTypeSpecificClick, proposalHeroColorTypes, proposalHeroTypes, typeIconMap } from "./ProposalHeroConfig"
import { ReactComponent as TriangularOutline } from "./assets/TriangularOutline.svg";
import { useEffect } from "react";
import { playInitialTweens, proposalHeroTriangleTimeline, proposalHoverTriangleTimeline, reverseProposalHeroTriangleTimeline } from "./ProposalHeroTweens";

function ProposalHeroTriangle({ id, currentCard, setCurrentCard, prevCard, setPrevCard, isHover, toggleModal, setIsHover, proposalData, containerType, isInvertedTriangle, setIsError }) {
  const { color, collateralData: { headingText, backgroundImage }, data: { type, pdf: pdfFile, link, video, images } } = proposalData;


  useEffect(() => {
    if (id === currentCard) {
      proposalHeroTriangleTimeline(id, color).play();
    }
    else {
      reverseProposalHeroTriangleTimeline(prevCard, color).play();
    }
  }, [currentCard])


  useEffect(() => {
    playInitialTweens(containerType, currentCard, id);
    const heroError = handleHeroMediaType(type, pdfFile, link, video, images, setIsError);
    setIsError(prev => [...prev, heroError]);
  }, [])
  function handleMouseEnter() {
    setIsHover(true)
    setPrevCard(currentCard)
    setCurrentCard(id);
    proposalHoverTriangleTimeline(id).play();
  }
  function handleMouseLeave() {
    proposalHoverTriangleTimeline(id).reverse(0);
    setIsHover(false)
  }
  function handleClick() {
    handleTypeSpecificClick({ type, pdfFile, link, setShowProposalModal: () => toggleModal({ images, video, type }) });
  }

  return (
    <>

      <div className={classNames("ProposalHeroTriangleContainer relative flex align-items-center justify-content-center h-full w-full ", `ProposalHeroTriangleContainer-${id}`, color ?? proposalHeroColorTypes.orange, { "isInvertedTriangle": isInvertedTriangle && containerType === proposalHeroTypes.triangle.label })}>
        <div className={classNames("ProposalHeroTriangle h-full w-full z-0 relative overflow-hidden ", borderRadius[containerType], containerType)} >
          <div className="ClickHandler z-5 absolute left-50 top-50 cursor-pointer pointer-events-auto" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick}></div>
          <img className="z-0 h-full w-full  bg-no-repeat bg-cover" style={{ backgroundImage: `url(${backgroundImage.url})` }} />
          <div className={classNames("ProposalHeroTriangleGradientOverlay absolute top-0 left-0 z-1 h-full w-full", containerType, borderRadius[containerType], color ?? proposalHeroColorTypes.orange)}></div>
          <TriangularOutline className="ProposalHeroTriangleOutline h-full w-full absolute top-0 left-0 z-2" />
          <div className="ProposalHeroTriangleOverlay absolute top-0 left-0 z-2 h-full w-full"></div>
          <p className="ProposalHeroTriangleContent absolute z-2 top-50 left-50 p-3 text-sm text-white text-center uppercase">
            {headingText}
          </p>
          {
            isHover && id === currentCard &&
            <i className="ProposalHeroTriangleContentIcon z-2 absolute top-50 left-50">{typeIconMap[type]}</i>
          }
        </div>
      </div>
    </>
  )
}

export default ProposalHeroTriangle